import { Icon } from "@iconify/react";
import React from "react";
import { useHistory } from "react-router-dom";

const PaymentSuccess = () => {
  const history = useHistory();
  const backtohome = () => {
    history.push(`/dashboard`);
  };

  return (
    <div
      className="payment_pop"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div
        className="popping"
        style={{
          textAlign: "center",
          boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
          padding: "30px",
          borderRadius: " 10px",
        }}
      >
        <div className="mb-5 w-full flex flex-col items-center justify-center">
          <div className="mb-5">
            <Icon
              icon="ph:seal-check-fill"
              style={{ fontSize: "6em", color: "#3973b7" }}
            />
          </div>
          <h1 className="mb-5 !font-semibold">Payment Successful!</h1>
          <h3 className="!text-description !text-xl">
            Thank you for your business.
          </h3>
        </div>
        <button
          className="sign_btn"
          style={{ fontSize: "20px" }}
          onClick={backtohome}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
